<template>
  <div>
    <div class="es-op-box">
      <el-input placeholder="请输关键字" v-model="queryObj.keyWord" size="small" class="query" style="float: left" clearable
        @change="() => { this.queryObj.pageNum = 1; init() }">
        <i slot="suffix" class="el-input__icon el-icon-search"></i>
      </el-input>
      <el-button type="primary" icon="el-icon-font el-icon-web__tianjia" size="mini" style="margin-right:6px"
        @click="add_init">新增</el-button>
      <es-delete @del="del()" type="button"></es-delete>
    </div>
    <el-table :data="pageData.list" ref="knowledgeTable" border stripe size="mini" height="calc(100vh - 180px)"
      v-loading="loading">
      <el-table-column type="selection" width="40" align="center">
      </el-table-column>
      <el-table-column type="index" label="序号" width="50" align="center">
      </el-table-column>
      <el-table-column prop="title" width="150" label="标题">
      </el-table-column>
      <el-table-column prop="bussTypeId" width="150" label="类型">
        <template slot-scope="scope">
          <span v-if="scope.row.bussTypeId == 0">故障</span>
          <span v-if="scope.row.bussTypeId == 1">巡检</span>
          <span v-if="scope.row.bussTypeId == 2">保养</span>
          <span v-if="scope.row.bussTypeId == 3">通用</span>
        </template>
      </el-table-column>
      <el-table-column prop="content" label="内容">
      </el-table-column>
      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="scope">
          <el-link :underline="false" title="附件" @click="edit_file(scope.row)" type="primary"><i
              class="el-icon-upload "></i></el-link>
          <el-divider direction="vertical"></el-divider>
          <el-link :underline="false" title="编辑" @click="edit_init(scope.row)" type="primary"><i
              class="el-icon-font el-icon-bianji"></i></el-link>
          <el-divider direction="vertical"></el-divider>
          <el-link :underline="false" title="查看" @click="view_init(scope.row)" type="primary"><i
              class="el-icon-font el-icon-view"></i></el-link>
          <el-divider direction="vertical"></el-divider>
          <es-delete @del="del(scope.row.id)" :key="scope.row.id" type="icon"></es-delete>
        </template>
      </el-table-column>
    </el-table>
    <div class="es-page-box">
      <es-pagination :data="pageData" @change="(cpage) => { this.queryObj.pageNum = cpage; this.loadknowledgeList() }">
      </es-pagination>
    </div>
    <!--编辑知识库-->
    <el-dialog :visible.sync="editVisible" width="1000px"
      @closed="() => { this.$refs['knowledgeForm'].clearValidate(); this.$refs.myEditor.editor.txt.clear(); }">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑知识库
      </span>
      <el-form :model="knowledgeInfo" :rules="rules" size="mini" label-position="right" label-width="100px"
        ref="knowledgeForm">

        <el-form-item prop="bussTypeId" label="业务类型">
          <el-col :span="7">
            <el-select v-model="knowledgeInfo.bussTypeId" style="display: block;" placeholder="请选择知识类型">
              <el-option label="故障" :value="0"></el-option>
              <el-option label="巡检" :value="1"></el-option>
              <el-option label="保养" :value="2"></el-option>
              <el-option label="通用" :value="3"></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        <el-form-item prop="equiTypeId" label="设备类型">
          <el-col :span="7">
            <template>
              <el-select v-model="knowledgeInfo.equiTypeId" style="display: block;" width="200px" clearable
                @change="$forceUpdate();" placeholder="请选择">
                <el-option v-for="item in equiTypeOptions" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </template>
          </el-col>
        </el-form-item>
        <el-form-item prop="title" label="标题">
          <el-col :span="7">
            <el-input size="small" v-model="knowledgeInfo.title" placeholder="请输入知识库" width="200px" clearable>
            </el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="知识内容" prop="content">
          <el-col :span="23">
            <eswangEditor ref="myEditor" class="myEditor" @sendEditor="sendEditor" :key="$route.fullPath" />
          </el-col>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini" @click="editVisible = false">取 消</el-button>
        <el-button type="primary" size="mini" @click="submitKnowledge()" :loading="saving">保 存</el-button>
      </span>
    </el-dialog>
    <!--查看知识库-->
    <el-dialog :visible.sync="viewVisible" width="1000px" @closed="() => { this.activeName = 'web'; }">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>预览知识库
      </span>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="web端" name="web">
          <el-container>
            <el-scrollbar style="height: 700px;width: 100%;">
              <el-main v-html="knowledgeInfo.content">
              </el-main>
            </el-scrollbar>
          </el-container>
          <el-col style="margin-top: 15px;">
            <el-link disabled>附件：</el-link>
            <el-link v-for="(item, index) in fileList" type="primary" @click="downFile(item)" :key="index">{{ item.name
            }}&nbsp;&nbsp;</el-link>
          </el-col>
        </el-tab-pane>
        <el-tab-pane label="手机端" name="mobile">
          <el-container direction="horizontal" style="width:100%;">
            <el-scrollbar class="el-scrollbar-main-mobile">
              <el-main class="el-scrollbar-main-mobile-context">
                <div v-html="knowledgeInfo.content"></div>
                <el-table :data="fileList" ref="knowledgeFileTable" stripe size="mini" width="100%">
                  <el-table-column prop="name" width="" label="附件：">
                    <template slot-scope="scope">
                      <el-link :underline="false" @click="downFile(scope.row)" type="primary">{{
                          scope.row.name
                      }}</el-link>
                    </template>
                  </el-table-column>
                </el-table>
              </el-main>
            </el-scrollbar>
          </el-container>

        </el-tab-pane>
      </el-tabs>

      <span slot="footer">
        <el-button size="mini" @click="() => { this.activeName = 'web'; this.viewVisible = false }">取 消</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="dialogFileVisible" width="600px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>附件编辑
      </span>
      <div style="margin-top: 10px;" v-loading="loadingFile">
        <el-table :data="fileList" ref="knowledgeFileTable" border stripe size="mini" width="100%">
          <el-table-column type="index" label="序号" width="50" align="center">
          </el-table-column>
          <el-table-column prop="name" width="" label="文件名称">
          </el-table-column>
          <el-table-column prop="size" width="" label="文件大小(KB)">
            <template slot-scope="scope">
              {{ (scope.row.size / 1024).toFixed(1) }}
            </template>
          </el-table-column>
          <el-table-column width="80" label="操作" align="center">
            <template slot-scope="scope">
              <el-link :underline="false" title="附件" @click="downFile(scope.row)" type="primary"><i
                  class="el-icon-download"></i></el-link>
              <el-divider direction="vertical"></el-divider>
              <es-delete @del="delFile(scope.row)" :key="scope.row.id" type="icon"></es-delete>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer">
        <!-- <el-button size="mini" @click="dialogFileVisible = false">取 消</el-button> -->
        <el-upload :action="getUploadAction()" accept=".doc,.xls,.ppt,.pdf,.docx,.xlsx,.pptx,.pptm"
          :beforeUpload="beforeUpload" :headers="{ token: this.$store.getUser().token, platform: 'web' }"
          :show-file-list="false" :file-list="fileList" :on-success="handleSuccess" :on-error="handleError"
          :on-exceed="handleExceed" :data="{ busCode: 'knowledge', type: 'files' }">
          <el-button size="small" type="primary" style="mar">点击上传</el-button>
        </el-upload>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import eswangEditor from "../common/es-wangEditor.vue";
export default {
  components: {
    eswangEditor,
  },
  name: 'role',
  props: ["funcs"],
  data () {
    return {
      dialogTile: "新建知识库",
      fileList: [],
      activeName: "web",
      viewVisible: false,
      queryObj: { pageNum: 1, pageSize: 20 },//查询条件
      pageData: {},
      editVisible: false,
      equiTypeVisible: false,
      dialogFileVisible: false,
      knowledgeInfo: {},//系统信息
      knowledgeFileInfo: {},
      rules: {//验证条件
        bussTypeId: [
          { required: true, message: '请输选择业务类型', trigger: 'blur' },
        ],
        title: [
          { required: true, message: '请输输入标题', trigger: 'blur' },
        ]
      },
      equiTypeOptions: [],
      loading: false,
      loadingFile: false,
      saving: false,
    }
  },
  methods: {
    //页面初始化
    init () {
      this.equiTypeListAll();
      this.loadknowledgeList()
    },
    edit_file (row) {
      this.dialogFileVisible = true
      console.log('edit_file')
      this.knowledgeFileInfo = row
      if (this.knowledgeFileInfo.attachFiles != null) {
        this.fileList = JSON.parse(this.knowledgeFileInfo.attachFiles)
      } else {
        this.fileList = []
      }

      console.log('edit_file', this.fileList)
    },
    downFile (row) {
      this.loadingFile = true
      const x = new window.XMLHttpRequest();
      x.open('GET', this.$api + row.url + '&platform=web&token=' + this.$store.getUser().token, true);
      x.responseType = 'blob';
      x.onload = () => {
        const url = window.URL.createObjectURL(x.response);
        const a = document.createElement('a');
        a.href = url;
        a.download = row.name;
        a.click();
        this.loadingFile = false
      };
      x.send();
      this.loadingFile = false
    },
    sendEditor (val) {
      this.knowledgeInfo.content = val;
    },
    getKnowledgeById (val) {
      let id = val.id
      if (id != null) {
        this.loading = true;
        this.$ajax
          .get("/base/knowledge/getKnowledgeById", { id: id })
          .then((msg) => {
            console.log(msg);
            this.knowledgeInfo = msg;
            this.$nextTick(() => {
              this.$refs.myEditor.editor.txt.html(this.knowledgeInfo.content);
            });
            this.loading = false;
          })
          .catch((err) => {
            this.$message.error(err);
            this.loading = false;
          });
      }
    },
    getKnowledgeByIdView (val) {
      let id = val.id
      if (id != null) {
        this.loading = true;
        this.$ajax
          .get("/base/knowledge/getKnowledgeById", { id: id })
          .then((msg) => {
            console.log(msg);
            this.knowledgeInfo = msg;
            if (this.knowledgeInfo.attachFiles != null) {
              this.fileList = JSON.parse(this.knowledgeInfo.attachFiles)
            } else {
              this.fileList = []
            }
            this.loading = false;
          })
          .catch((err) => {
            this.$message.error(err);
            this.loading = false;
          });
      }
    },
    //从后台查询知识库列表
    loadknowledgeList () {
      this.loading = true
      this.$ajax.get('/base/knowledge/list', this.queryObj).then(msg => {
        this.pageData = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })

    },
    //初始化添加知识库
    add_init () {
      this.dialogTile = "新建知识库"
      this.editVisible = true
      this.equiTypeVisible = false
      this.knowledgeInfo = {}
    },
    //初始化知识库
    edit_init (row) {
      this.editVisible = true
      this.dialogTile = "编辑知识库"
      this.getKnowledgeById(JSON.parse(JSON.stringify(row)))
    },
    view_init (row) {
      this.viewVisible = true;
      this.getKnowledgeByIdView(JSON.parse(JSON.stringify(row)))
    },
    handleClick (tab, event) {
      console.log(tab, event);
    },
    //保存知识库
    submitKnowledge () {
      this.$refs["knowledgeForm"].validate(valid => {
        if (valid) {
          let url = "/base/knowledge/add";
          if (this.knowledgeInfo.id != null) {
            url = "/base/knowledge/edit";
          }
          console.log("submitKnowledge", this.knowledgeInfo);
          this.saving = true
          this.$ajax.post(url, this.knowledgeInfo).then(msg => {
            this.saving = false
            this.loadknowledgeList()
            this.editVisible = false
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.saving = false
          })
        }
      })
    },
    //删除知识库
    del (delId) {
      let ids = []
      if (delId != null) {
        ids = [delId]
      } else {
        this.$refs["knowledgeTable"].selection.forEach((ele) => {
          ids.push(ele.id)
        })
      }
      if (ids.length > 0) {
        this.loading = true
        this.$ajax.post('/base/knowledge/delete', { 'ids': ids }).then(msg => {
          this.loading = false
          this.$message.success(msg)
          this.queryObj.pageNum = 1//删除之后，回到第一页
          this.loadknowledgeList()
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      }
    },
    equiTypeListAll () {
      this.loading = true
      this.$ajax.get('/base/assettype/list_all',).then(msg => {
        this.equiTypeOptions = msg;
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },
    beforeUpload (file) {
      this.loadingFile = true
      const sizeLimit = file.size / 1024 / 1024 > 50
      if (sizeLimit) {
        this.loadingFile = false
        this.$message.warning('上传文件大小不能超过 20MB!')
      }
      return !sizeLimit
    },
    handleSuccess (response, file) {
      console.log(response, file)
      // 存在bug，如果一个页面，同时用两个图片附件
      if (response.code == 200) {
        let tempFileList = new Array()
        if (this.knowledgeFileInfo.attachFiles != null) {
          tempFileList = JSON.parse(this.knowledgeFileInfo.attachFiles)
        }
        tempFileList.push({ name: file.name, size: file.size, url: '/file/file/down?filename=' + response.msg })
        this.knowledgeFileInfo.attachFiles = JSON.stringify(tempFileList)
        this.$ajax.post('/base/knowledge/editFile', { attachFiles: this.knowledgeFileInfo.attachFiles, id: this.knowledgeFileInfo.id }).then((msg) => {
          if (this.knowledgeFileInfo.attachFiles != null) {
            this.fileList = JSON.parse(this.knowledgeFileInfo.attachFiles)
          } else {
            this.fileList = []
          }
          this.$message.success(msg)
          this.loadingFile = false
        }).catch(err => {
          this.$message.error(err)
        })
      } else {
        this.$message.error(response.msg)
      }
    },
    delFile (row) {
      this.loadingFile = true
      let s = row.url.indexOf('=')
      let e = row.url.length
      let filename = row.url.substring(s + 1, e)
      let files = JSON.parse(this.knowledgeFileInfo.attachFiles)
      let newFiles = files.filter((e) => {
        return !e.url.includes(row.url.substring(0, row.url.indexOf('.')))
      })
      let param
      if (newFiles.length == 0) {
        param = null;
      } else {
        param = JSON.stringify(newFiles)
      }
      //物理删除
      this.$ajax.post("/file/file/delete", { fileName: filename }).then((msg) => {
        this.knowledgeFileInfo.attachFiles = JSON.stringify(newFiles)
        this.$ajax.post('/base/knowledge/editFile', { attachFiles: param, id: this.knowledgeFileInfo.id }).then(() => {
          if (this.knowledgeFileInfo.attachFiles != null) {
            this.fileList = JSON.parse(this.knowledgeFileInfo.attachFiles)
          } else {
            this.fileList = []
          }
          this.loadingFile = false
          this.$message.success(msg)
        }).catch(err => {
          this.loadingFile = false
          this.$message.error(err)
        })
      }).catch(err => {
        this.loadingFile = false
        this.$message.error(err)
      })
    },
    handleError () {
      this.loadingFile = false
      this.$message.error("上传附件失败，请确认文件是否超出")
    },
    handleRemove (file) {
      this.loadingFile = false
      let filename
      if (file.response != null) {
        filename = file.response.msg
      } else {
        let s = file.url.indexOf('=')
        let e = file.url.indexOf('&')
        filename = file.url.substring(s + 1, e)
      }
      let files = JSON.parse(this.info.attachImgs)
      let newFiles = files.filter((e) => {
        return !e.name.startsWith(file.name.substring(0, file.name.indexOf('.')))
      })

      //物理删除
      this.$ajax.post("/file/file/delete", { fileName: filename }).then((msg) => {
        this.info.attachImgs = JSON.stringify(newFiles)
        //如果是新增不做处理
        if (this.info.id != null) {
          //图片数据更新
          this.$ajax.post(this.dataUrl, { attachImgs: JSON.stringify(newFiles), id: this.info.id }).then(() => {
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
          })
        }
      }).catch(err => {
        this.$message.error(err)
      })
    },
    getUploadAction() {
      return   this.$api+"/file/file/upload";
    },
    handleExceed () {
      this.$message.error("超出最大上传附件数")
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style >
.editor-bar {
  border: 1px solid #c9d8db;
  border-bottom: 1px solid #c9d8db;
}

.editor-content {
  height: calc(100vh - 500px);
  border: 1px solid #c9d8db;
  border-top: none;
  min-height: calc(100vh - 500px);
}

.el-scrollbar__wrap {
  overflow-x: hidden;
}

.el-scrollbar .el-scrollbar__wrap {
  overflow-x: hidden;
}

.el-select-dropdown .el-scrollbar {
  padding-bottom: 17px;
}

.el-scrollbar-main-mobile {
  margin-left: 300px;
  width: 333px;
  height: 700px;
  background-image: url(../../assets/imgs/mobile.png);
}

.el-scrollbar-main-mobile-context {
  margin-left: 26px;
  width: 282px;
  height: 500px;
  margin-top: 98px;
  background-color: white;
}
</style>
